module.exports = __webpack_public_path__ + "static/media/pencil.cf3b7ce9.svg";